module.exports = __webpack_public_path__ + "img/gis.57d3da87.png";